import { Provider } from '@angular/core';
import { provideTranslateService, TranslateService } from '@ngx-translate/core';
import { provideTranslateHttpLoader } from '@ngx-translate/http-loader';
import { firstValueFrom } from 'rxjs';
import { DEFAULT_LANGUAGE, LANGUAGE_STORAGE_KEY } from './i18n.models';
import { I18nLocaleService } from './i18n-locale.service';

export function provideClientI18n(): Provider[] {
  return [
    ...provideTranslateService({
      fallbackLang: DEFAULT_LANGUAGE,
    }),
    ...provideTranslateHttpLoader({
      prefix: 'assets/i18n/',
      suffix: '.json',
    }),
  ];
}

export async function initClientI18n(
  translate: TranslateService,
  locale: I18nLocaleService,
): Promise<void> {
  const saved = localStorage.getItem(LANGUAGE_STORAGE_KEY);
  const language = saved === 'en' || saved === 'ms' ? saved : DEFAULT_LANGUAGE;

  translate.addLangs(['en', 'ms']);
  translate.setFallbackLang(DEFAULT_LANGUAGE);

  await firstValueFrom(translate.use(language));
  locale.persistLanguage(language);
}
